import { FeatureName } from '../../../utils';
import { useTosaUserFeature } from '../../useTosaUserFeature';

import type { NodeInputOptions, UseFeatureHook } from '../../../types';

interface UseAvailableHealthOptionsProps {
  useFeature: UseFeatureHook;
  options: NodeInputOptions[];
}

export function useAvailableHealthOptions({
  useFeature,
  options,
}: UseAvailableHealthOptionsProps): NodeInputOptions[] {
  const { treatment } = useTosaUserFeature({
    useFeature,
    featureName: FeatureName.CVR_HEALTH_ISSUE_URINARY_STONES,
  });

  const shouldDisplayUrinaryStones = treatment === 'on';

  // Filter out options that are pending rollout
  return shouldDisplayUrinaryStones
    ? options
    : options.filter(option => option.name.toLowerCase() !== 'urinary stones');
}
